const treeLeavesCache = new Map();
const treeLeavesPending = new Map();

function makeLeavesCacheKey(micro_id, snp_dist) {
  return `${micro_id}::${snp_dist}`;
}

export async function fetchTreeLeaves(api, micro_id, snp_dist) {
  const cacheKey = makeLeavesCacheKey(micro_id, snp_dist);

  if (treeLeavesCache.has(cacheKey)) {
    const cached = treeLeavesCache.get(cacheKey);
    return Array.isArray(cached) ? [...cached] : cached;
  }

  if (treeLeavesPending.has(cacheKey)) {
    const pending = treeLeavesPending.get(cacheKey);
    const result = await pending;
    return Array.isArray(result) ? [...result] : result;
  }

  const requestPromise = (async () => {
  try {
    const response = await api.get(
      `/tree/${micro_id}/snps/${snp_dist}/constrain/0`
    );
    const result = response.body;

    if (result.tree) {
      const value = Array.isArray(result.tree)
        ? [...result.tree]
        : result.tree;
      treeLeavesCache.set(cacheKey, value);
      return value;
    } 
    // if (result.tree) {
    //   const tokens = result.tree
    //     .split(/\s*(;|\(|\)|,|:)\s*/)
    //     .filter((token) => token.length > 1);

    //   const response1 = await api.get("/seq_id_list_to_details", {
    //     seq_ids: tokens,
    //   });
    //   if (response1.ok) {
    //     const details = Object.values(response1.body.details);
    //     console.log("Details:", details);
    //     const pids = details.map((pt) => pt.seq_id);
    //     console.log("Tree leaves:", pids);
    //     // const filtered = micro_ids.filter((id) => id !== micro_id);
    //     // console.log("Filtered tree leaves:", filtered)
    //     return pids;
    //   }
    // }
  } catch (error) {
    // Handle error if needed
    console.error("Error fetching tree leaves:", error);
    throw error; // Rethrow the error to propagate it further if needed
  }
  })().finally(() => {
    treeLeavesPending.delete(cacheKey);
  });

  treeLeavesPending.set(cacheKey, requestPromise);
  const resolved = await requestPromise;
  return Array.isArray(resolved) ? [...resolved] : resolved;
}

export async function fetchSeqIDDistance(api, index_seq_id, seq_ids) {
  try {
    // Construct query parameters; assuming seq_ids is an array.
    const queryParams = new URLSearchParams();
    queryParams.append("index_seq_id", index_seq_id);
    seq_ids.forEach(seq => queryParams.append("seq_ids", seq));
    
    const response = await api.get(`/seq_id_list_to_snp_distance?${queryParams.toString()}`);
    if (response.ok) {
      console.log("Response:", response.body);
      return response.body;
    }
  } catch (error) {
    console.error("Error fetching sequence ID distance:", error);
    throw error;
  }
}
